import type React from 'react';

export interface IProps {}

const ClickFieldRequired: React.FC<IProps> = () => {
  return <span className="text-normal pl-px text-rose-600">*</span>;
};

export default ClickFieldRequired;
